import React, { useEffect } from 'react';

// components
import Button from '../../../components/Button';
import DocumentCamera from '../../../components/DocumentCamera';
import Title from '../../../components/Title';

import { useStore } from '../../../context/appContext';
import { modalTypes } from '../../../context/types';
import useGAEventsTracker from '../../../utils/useGAEventsTrackers';

function Documents() {
  const { setModal, stepForward, photosUri } = useStore();

  const GAEventsTracker = useGAEventsTracker("Documents Page");
  useEffect(() => {
    GAEventsTracker("Visualiza pantalla fotos DNI");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);  
  
  useEffect(() => {
    if (photosUri.front || photosUri.back) return;
    setModal({
      open: true,
      type: modalTypes.documentInfo,
    });
    return () => {
      setModal({
        open: false,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const handleSubmit = () => {
    if (!photosUri.front || !photosUri.back) return;
    GAEventsTracker("Boton Continuar");
    stepForward();
  };
  
  return (
    <>
      <Title grid="title">Foto de tu DNI</Title>
      <DocumentCamera />
      <Button
        filled={!!photosUri.front && !!photosUri.back}
        grid="buttons"
        onClick={handleSubmit}
      >
        Continuar
      </Button>
    </>
  );
}

export default Documents;
